import { Component } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import { CategoryProviderService } from '../../provider/category.provider';
import { SearchDisplayCheck } from '../../provider/searchVisibility';
/**
 * Generated class for the ParenttabsPage tabs.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'category-page',
  templateUrl: 'category.html',
})
export class CategoryPage {

  name = '';
  visible = false;
  loading;

  private jsondata;
  categories: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private catgService: CategoryProviderService,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private addtab: SearchDisplayCheck) {
    this.name = this.navParams.data.user1;
    console.log('Passed params', this.navParams.data);
  }


  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }

  swipeEvent(e) {
    console.log('swiped');
  }

  ionViewDidEnter() {
    console.log('Enter view');
    this.getDeals();
    this.presentLoading();
  }

  ionViewWillLeave() {
    console.log('Leave view');
  }

  getDeals() {
    this.catgService.getCategorries('').subscribe(data => {

      console.log('status::::' + data.status);
      console.log('data::::' + data); // data received by server
     // this.jsondata = JSON.parse(data.data);

      this.categories = data.Categories;
      this.visible = true;
      if (this.loading != null) {
        this.loading.dismiss();
      }


    }, (error => {
        console.log(error.status);
        console.log(error.error); // error message as string
        console.log(error.headers);
        if (this.loading != null) {
          this.loading.dismiss();
        }

      }));
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({

    });

    this.loading.present();

  }

  clickevent(data, i, j) {
    const catid = data.CategoryID;
    const subcatid = data.SubCategory[j].SubCategoryID;
    const subcatname = data.SubCategory[j].SubCategoryName;
    console.log('cat subcat' + catid + subcatid);
    const tabdata = {
      'tabenable': true, 'ScreenTitle': this.navParams.data.ScreenTitle, 'CategoryID': catid,
      'SubCategoryID': subcatid, 'subcatname': subcatname, 'SearchTypeID': this.navParams.data.SearchTypeID
    };
    this.addtab.addTab(tabdata);
  }

  toggleSection(i) {
    this.categories[i].open = !this.categories[i].open;
  }

  toggleItem(i, j) {
    this.categories[i].SubCategory[j].open = !this.categories[i].SubCategory[j].open;
  }

}

